import React, { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { SubTitle1 } from '../../atoms';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';

import './crud-delete-dialog.styles.scss';

export interface ICrudDeleteDialogProps {
	open: boolean;
	onClose: () => void;
	possibleCascade?: boolean;
	onConfirm: () => void;
}

export function CrudDeleteDialog(props: ICrudDeleteDialogProps): ReactElement {
	const { open, onClose, possibleCascade, onConfirm } = props;
	const { t } = useTranslation('contentManager');

	return (
		<ConfirmationDialog
			className="delete-dialog"
			title={t('dialog.delete.confirmDelete')}
			open={open}
			confirmText={t('dialog.delete.deleteText')}
			bodyText={DeleteDialogBody(possibleCascade)}
			onCancel={onClose}
			onConfirm={onConfirm}
		/>
	);
}

function DeleteDialogBody(possibleCascade?: boolean): ReactNode {
	const { t } = useTranslation('contentManager');

	return (
		<>
			<SubTitle1>{t('dialog.delete.cannotBeUndone')}</SubTitle1>
			{possibleCascade && (
				<SubTitle1 className="cascade-warning">
					{t('dialog.delete.deletionOfLinkedItems')}
				</SubTitle1>
			)}
		</>
	);
}
